export type FlowRole = 'PATIENT' | 'DOCTOR' | 'SYSTEM';

export type FlowLogPayload = Record<string, unknown> & {
  screen?: string;
  action?: string;
  role?: FlowRole;
  appointmentId?: number | string | null;
  specialtyId?: number | string | null;
  consultationId?: number | string | null;
};

const recentFlowLogs = new Map<string, number>();
const FLOW_LOG_DEDUPE_MS = 750;
const isDev = process.env.NODE_ENV === 'development';

const buildFlowLogKey = (scope: string, message: string, payload?: FlowLogPayload) =>
  [scope, message, payload?.action ?? '', payload?.appointmentId ?? '', payload?.screen ?? ''].join('|');

export const flowLog = (scope: string, message: string, payload?: FlowLogPayload) => {
  if (isDev) {
    const key = buildFlowLogKey(scope, message, payload);
    const now = Date.now();
    const lastAt = recentFlowLogs.get(key);

    if (lastAt !== undefined && now - lastAt < FLOW_LOG_DEDUPE_MS) {
      return;
    }

    recentFlowLogs.set(key, now);
  }

  console.log(`[FLOW][${scope}] ${message}`, {
    timestamp: new Date().toISOString(),
    ...payload,
  });
};

export const flowTimer = () => {
  const start = performance.now();
  return () => Math.round(performance.now() - start);
};
